// extracted by mini-css-extract-plugin
export default {"users":"UsersList_users__qDCs9"};